import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { withValue } from '@g4/automation-hooks';

import { Box, Media, Text } from '../../../../components/Boneyard';

const propTypes = {
  theme: PropTypes.object.isRequired,
  title: PropTypes.string,
  automationHook: PropTypes.string,
  fwdRef: PropTypes.object
};

const FlightDetailsTitle = ({ automationHook, theme, title, fwdRef }) => {
  // ref used for scrolling target passed from parent
  return (
    <Media>
      {mq => (
        <Box d="flex" position="relative" alignItems="center">
          <Text
            size={mq.lt('md') ? 18 : 30}
            weight={500}
            color={theme.colors.flights.flightDetails.title}
            automationHook={withValue(automationHook, 'flight-title')}
          >
            <span ref={fwdRef}>{title}</span>
          </Text>
        </Box>
      )}
    </Media>
  );
};

FlightDetailsTitle.propTypes = propTypes;
FlightDetailsTitle.displayName = 'FlightDetailsTitle';

export default withTheme(FlightDetailsTitle);
